import { TKIconBtnArrowRight } from "assets/images/svgs"

const Button = ({ children, className, onClick, type, textColor }) => {
  return (
    <button type={type} onClick={onClick} className='relative text-[#000] cursor-pointer '>
      <div className='flex w-[160px] h-[45px] rounded bg-[#CCCCCC]'></div>
      <div className={`flex absolute rounded shadow top-0 w-[160px] h-[45px] transform -rotate-5 transition-all duration-300 hover:rotate-0 ${className}`}></div>
      <div className="absolute bottom-[13px] left-[23px] flex items-center justify-center">
        <p className={`font-bold text-[12px] uppercase tracking-widest mr-2 whitespace-nowrap ${textColor}`}>{children}</p>
        <TKIconBtnArrowRight />
      </div>
    </button>
  )
}

export default Button